<template>
  <section class="background-to-almighty-gods-work-wrap" v-parallax>
    <v-page
      :background="[
        'images/background-to-Almighty-God-s-work/bg-0.jpg',
        'images/background-to-Almighty-God-s-work/bg-0-front.png',
      ]"
      :slide-up-in="true"
      v-slide-up-in
      v-parallax-background
    >
      <v-chapter-title
        :chapTip="firstPageData.episode"
        :chapterTitle="chapterTitle"
        :stageTitle="firstPageData.stage"
        v-slide-up-in-stage="1"
      />
      <v-btn class="down-arrow"><v-icon>expand_more</v-icon></v-btn>
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-text-content :html="pageDataItem.page1.data.content" />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/background-to-Almighty-God-s-work/page1ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page2.data"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-text-content :html="pageDataItem.page3.data.content" />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-float-image-content :data="pageDataItem.page4.data.content" />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/background-to-Almighty-God-s-work/page5ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page5.data"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-chatper-entry class="margin0" />
    </v-page>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("global", ["schema"]),
  },
  components: {},
  data() {
    return {
      pageDataItem: {},
      chapterTitle: "",
      firstPageData: "",
    };
  },

  created() {
    this.pageDataItem = this.schema["background-to-Almighty-God-s-work"].item;
    this.chapterTitle = this.schema.global.item[
      "the-word-appears-in-the-flesh"
    ].title;
    this.firstPageData = this.schema.global.item.aside.data[2];
  },
};
</script>

<style lang="scss">
.background-to-almighty-gods-work-wrap {
  .v-page-content {
    .chapter-switch-entry {
      padding-top: 140px;
    }
  }
}
</style>
